import { RECAPTCHA_SITE_KEY } from '../constants';
import { getRecaptchaToken } from '../utils/recaptcha';

/** Header name for reCAPTCHA v3 token (must match server). */
const RECAPTCHA_TOKEN_HEADER = 'X-Recaptcha-Token';

/**
 * Helper: Handle API response
 * @param {Response} response - Fetch response object
 * @returns {Promise<*>} Parsed JSON response
 */
export const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
    const error = new Error(errorData.error || `HTTP ${response.status}`);
    error.status = response.status;
    error.statusText = response.statusText;
    throw error;
  }
  return response.json();
};

/**
 * JSON fetch with optional reCAPTCHA v3 token (X-Recaptcha-Token) when RECAPTCHA_SITE_KEY is set.
 * @param {string} url - Request URL
 * @param {Object} options - Fetch options; may include `recaptchaAction` (stripped before fetch)
 * @returns {Promise<*>} Parsed JSON response
 */
export const fetchJson = async (url, options = {}) => {
  const { recaptchaAction = 'awatch', ...fetchOpts } = options;
  const headers = {
    'Content-Type': 'application/json',
    ...fetchOpts.headers,
  };

  if (RECAPTCHA_SITE_KEY) {
    const token = await getRecaptchaToken(RECAPTCHA_SITE_KEY, recaptchaAction);
    if (token) {
      headers[RECAPTCHA_TOKEN_HEADER] = token;
    }
  }

  const requestOptions = {
    ...fetchOpts,
    headers,
  };
  const response = await fetch(url, requestOptions);
  return handleResponse(response);
};
